var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicIndoorpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.415,
    height: 19.852,
    viewBox: "0 0 10.415 19.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:none;stroke:#353841;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-717.176 -468.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.38,17.1a1.068,1.068,0,0,1-.791-.3,1.091,1.091,0,0,1-.3-.808V6.052a1.016,1.016,0,0,1,.28-.765,1.064,1.064,0,0,1,.774-.272H6.528a4.325,4.325,0,0,1,2.992.96A3.433,3.433,0,0,1,10.591,8.67a3.459,3.459,0,0,1-1.071,2.7,4.3,4.3,0,0,1-2.992.969H3.485V16a1.091,1.091,0,0,1-.3.808A1.091,1.091,0,0,1,2.38,17.1Zm3.876-6.443q2.261,0,2.261-1.972T6.256,6.715H3.485v3.944Z",
    transform: "translate(717 471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6381,9216.613l4.078-3.425,4.078,3.425",
    transform: "translate(-5662.768 -8744.188)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIndoorpark);
export default __webpack_public_path__ + "static/media/public_indoorpark.2c0bd3a18571fe1885c969fba137f7e4.svg";
export { ForwardRef as ReactComponent };